import { render, staticRenderFns } from "./CategoriaLoading.vue?vue&type=template&id=6d567ee2&scoped=true&"
import script from "./CategoriaLoading.vue?vue&type=script&lang=js&"
export * from "./CategoriaLoading.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaLoading.vue?vue&type=style&index=0&id=6d567ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d567ee2",
  null
  
)

export default component.exports